import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { IOrderRequestsResponse } from '../../types/api/orderRequestsApi';
import { getOrderRequestDetailService, getOrderRequestsDataService, postOrderToSapService, updateOrderRequestDetailService } from '../../api/orderRequestsApi';
import { OrderRequestsState } from '../../types/features/orderRequestsSlice';
import { ITableRequestData } from '../../types/common';



export const getOrderRequestsData = createAsyncThunk<IOrderRequestsResponse, ITableRequestData>(
    'orderRequests/getOrderRequestsData',
    async ({ limit, page, status }) => {
        const response = await getOrderRequestsDataService({ limit, page, status });
        return response.data;
    }
);

export const getOrderRequestDetailData = createAsyncThunk<IOrderRequestsResponse, { id: string }>(
    'orderRequests/getOrderRequestDetail',
    async ({ id }) => {
        const response = await getOrderRequestDetailService({ id });
        return response.data;
    }
);

export const updateOrderRequestDetailData = createAsyncThunk<IOrderRequestsResponse, { id: string, data: any }>(
    'orderRequests/updateOrderRequestDetail',
    async ({ id, data }) => {
        const response = await updateOrderRequestDetailService({ id, data });
        return response.data;
    }
);

export const postOrderToSap = createAsyncThunk<IOrderRequestsResponse, { data: any,id: string }>(
    'orderRequests/postOrderToSap',
    async ({ data,id }) => {
        const response = await postOrderToSapService({ data ,id });
        return response.data;
    }
);

const OrderRequestsSlice = createSlice({
    name: 'OrderRequests',
    initialState: {
        orderRequestsLoader: false,
        status: false,
        msg: '',
        data: null,
        detail: null
    } as OrderRequestsState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getOrderRequestsData.pending, (state) => {
                state.orderRequestsLoader = true;
            })
            .addCase(getOrderRequestsData.fulfilled, (state, action: PayloadAction<IOrderRequestsResponse>) => {
                state.data = action.payload.data;
                state.msg = action.payload.message;
                state.status = true;
                state.orderRequestsLoader = false;
            })
            .addCase(getOrderRequestsData.rejected, (state, action) => {
                state.orderRequestsLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })
            .addCase(getOrderRequestDetailData.pending, (state) => {
                state.orderRequestsLoader = true;
            })
            .addCase(getOrderRequestDetailData.fulfilled, (state, action: PayloadAction<IOrderRequestsResponse>) => {
                state.detail = action.payload.data;
                state.msg = action.payload.message;
                state.status = true;
                state.orderRequestsLoader = false;
            })
            .addCase(getOrderRequestDetailData.rejected, (state, action) => {
                state.orderRequestsLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })
            .addCase(updateOrderRequestDetailData.pending, (state) => {
                state.orderRequestsLoader = true;
            })
            .addCase(updateOrderRequestDetailData.fulfilled, (state, action: PayloadAction<IOrderRequestsResponse>) => {
                // state.detail = action.payload.data;
                state.msg = action.payload.message;
                state.status = true;
                state.orderRequestsLoader = false;
            })
            .addCase(updateOrderRequestDetailData.rejected, (state, action) => {
                state.orderRequestsLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })
            .addCase(postOrderToSap.pending, (state) => {
                state.orderRequestsLoader = true;
            })
            .addCase(postOrderToSap.fulfilled, (state, action: PayloadAction<IOrderRequestsResponse>) => {
                // // // console.log({ data: action.payload.data });

                // state.detail = action.payload.data;
                state.msg = action.payload.message;
                state.status = true;
                state.orderRequestsLoader = false;
            })
            .addCase(postOrderToSap.rejected, (state, action) => {
                state.orderRequestsLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })
    }
});

export default OrderRequestsSlice.reducer;
